const EVENT_URL = 'https://api.us-west-2.aws.tinybird.co/v0/events';

const trackEvent = async (name = '', payload = {}) => {
  const TOKEN = process.env?.TINYBIRD_TOKEN;
  if (process.env.NODE_ENV === 'development') {
    return;
  }

  try {
    await fetch(`${EVENT_URL}?name=${name}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ timestamp: new Date().toISOString(), ...payload })
    });
  } catch (e) {
    console.error(`[log] Failed to send ${name}.`);
  }
};

export { trackEvent };
